import React from "react";
import "./GenericSection.css";

const GenericSection = ({ id, children, navigateToSection }) => {
  return (
    <div id={id}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { navigateToSection })
      )}
    </div>
  );
};

export default GenericSection;
